export type ActivityFile = {
  name: string;
  size?: number;
  type?: string;
};

export type ActivityEntry = {
  id: string;
  createdAt: string;
  toolId: string;
  toolTitle: string;
  action: string;
  inputs: ActivityFile[];
  outputs: ActivityFile[];
  note?: string;
};

export type ActivityDraft = Omit<ActivityEntry, 'id' | 'createdAt'>;

const STORAGE_KEYS = ['pdfka:activityLog:v1', 'pdfka.activityLog.v1'];

export function fileToActivityFile(file: File): ActivityFile {
  return {
    name: file.name,
    size: file.size,
    type: file.type || undefined,
  };
}

export function bytesToActivityFile(
  filename: string,
  bytes: Uint8Array,
  type?: string,
): ActivityFile {
  return {
    name: filename,
    size: bytes.length,
    type,
  };
}

export function recordActivity(_draft: ActivityDraft): void {
  try {
    removeStoredActivityLog();
  } catch {
    // File operations should never fail because optional local metadata cleanup is unavailable.
  }
}

export function getActivityLog(): ActivityEntry[] {
  return [];
}

export function clearActivityLog(): void {
  try {
    removeStoredActivityLog();
    window.dispatchEvent(new CustomEvent('pdfka:activity-log'));
  } catch {
    // Ignore storage errors.
  }
}

function removeStoredActivityLog(): void {
  for (const key of STORAGE_KEYS) localStorage.removeItem(key);
}
